import React, { useState } from 'react';
import { Typography, Box, DialogContent, TextField, IconButton, MenuItem, Divider } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Send as SendIcon } from '@mui/icons-material';
import { useBody } from '../../Body/state/BodyContext';

const formatDate = (dateStr) => {
    return dateStr ? dateStr.split('T')[0] : "";
};

const DetallesTraduccionModal = ({ autorizacion = false, traductors, selectedDetail, handleInputChange, handleSubmit, editedRows }) => {
    const { setMessage } = useBody();
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedTraductor, setSelectedTraductor] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            if (file.size > 10 * 1024 * 1024) {
                setMessage('El archivo excede el tamaño máximo permitido de 10 MB.');
                return;
            }

            if (file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                setMessage('Solo se permiten archivos con extensión .docx.');
                return;
            }

            setSelectedFile(file);
        }
    };

    const handleTraductorChange = (e) => {
        const traductor = traductors.find(t => t.id === e.target.value);
        setSelectedTraductor(traductor);
    };

    const handleLocalSubmit = () => {
        handleSubmit({
            original: {
                ...selectedDetail.original,
                selectedFile,
                selectedTraductor,
            }
        });
    };

    return (
        <Box>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography>
                        <strong>Fecha pedido:</strong> {formatDate(selectedDetail?.original?.createdAt)}
                    </Typography>

                    <Typography>
                        <strong>Fecha límite:</strong> {formatDate(selectedDetail?.original?.deadline)}
                    </Typography>

                    <Typography>
                        <strong>Email de contacto:</strong>{" "}
                        {selectedDetail?.original?.petitioner_name
                            ? `${selectedDetail.original.petitioner_name}@frba.utn.edu.ar`
                            : ""}
                    </Typography>

                    <Typography>
                        <strong>Título de la tarea:</strong> {selectedDetail?.original?.title || ""}
                    </Typography>

                    <Typography>
                        <strong>Tarea a realizar:</strong> {selectedDetail?.original?.type?.value || ""}
                    </Typography>

                    <Typography>
                        <strong>Motivo del pedido:</strong> {selectedDetail?.original?.reason?.value || ""}
                    </Typography>

                    <Typography>
                        <strong>Departamento:</strong> {selectedDetail?.original?.department?.value || ""}
                    </Typography>

                    {!autorizacion && (
                        <>
                            <Typography
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                }}
                            >
                                <strong>Observaciones:</strong>{" "}
                                {selectedDetail?.original?.observation || "Sin observaciones"}
                            </Typography>

                            <Typography>
                                <strong>Cantidad de Palabras:</strong>{" "}
                                {selectedDetail?.original?.word_quantity || "Sin especificar"}
                            </Typography>
                            <Divider />
                            <Typography mt={1}>
                                <strong>Traductor Asignado</strong>{" "}
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                label="Seleccionar"
                                value={selectedTraductor?.id || ''}
                                onChange={handleTraductorChange}
                                size="small"
                            >
                                {traductors.map((traductor) => (
                                    <MenuItem key={traductor.id} value={traductor.id}>
                                        {traductor.username}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <Typography>
                                <strong>Subir Documento</strong>{" "}
                            </Typography>
                            <input
                                type="file"
                                name="adjunto"
                                onChange={handleFileChange}
                                accept=".docx"
                            />
                            <Typography>
                                <strong>Enviar Traducción</strong>{" "}
                            </Typography>
                            <Box>
                                <IconButton
                                    onClick={handleLocalSubmit}
                                    disabled={!selectedFile || !selectedTraductor}
                                >
                                    <SendIcon sx={{ color: (!selectedFile || !selectedTraductor) ? '#ccc' : '#b71234' }} />
                                </IconButton>
                            </Box>
                        </>
                    )}

                    {autorizacion && (
                        <>
                            <Typography>
                                <strong>Cantidad de Palabras:</strong>{" "}
                            </Typography>
                            <TextField
                                type="number"
                                size="small"
                                value={editedRows[selectedDetail.id]?.word_quantity || selectedDetail.original?.word_quantity}
                                onChange={(e) =>
                                    handleInputChange(selectedDetail.original.id, 'word_quantity', e.target.value)
                                }
                            />
                            <Typography>
                                <strong>Observación:</strong>{" "}
                            </Typography>
                            <TextField
                                size="small"
                                value={editedRows[selectedDetail.id]?.observation || selectedDetail.original?.observation}
                                onChange={(e) =>
                                    handleInputChange(selectedDetail.original.id, 'observation', e.target.value)
                                }
                            />
                            <Box>
                                <IconButton onClick={() => handleSubmit(selectedDetail, 2)} color="success">
                                    <CheckIcon />
                                </IconButton>
                                <IconButton onClick={() => handleSubmit(selectedDetail, 3)} color="error">
                                    <ClearIcon />
                                </IconButton>
                            </Box>
                        </>
                    )}
                </Box>
            </DialogContent>
        </Box>
    );
};

export default DetallesTraduccionModal;
